/**
 * Settings service - uses RepositoryFactory.settingsRepository (localStorage).
 * Replaces SettingsController for migrated features.
 */
import RepositoryFactory from "domain/adapter/RepositoryFactory";
import type { Locale, Settings } from "common/models/settings/Settings";

export const settingsService = {
    getSettings: () => RepositoryFactory.settingsRepository.getSettings(),
    setSettings: (settings: Partial<Settings>) => RepositoryFactory.settingsRepository.setSettings(settings),
    getLocale: () => RepositoryFactory.settingsRepository.getLocale(),
    setLocale: (locale: Locale) => RepositoryFactory.settingsRepository.setLocale(locale),
};
